import * as THREE from 'three';
import { gsap } from "gsap";
//import {Keywords,KeywordToData} from './keywords.js';
import {degrees_to_radians} from './Utils.js';

import { clone } from 'three/examples/jsm/utils/SkeletonUtils.js';
import {EventEmitter} from '@billjs/event-emitter';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

const getDistance = (x1, y1, x2, y2) =>{
  let y = x2 - x1;
  let x = y2 - y1;

  return Math.sqrt(x * x + y * y);
}

const PLACE_WORDS = true;

// states:
// tile-hidden : word is under tile out of sight
// time-showing : word is popped up over ground floating above tile
// tile-closeto : word is close to flamingo and should show itself
// bird : word follows flying bird
// remove: word should be removed from scene
// chosen : word was selected by flamingo

export default class WordSoup  extends EventEmitter{

  constructor(scene){
    super();
    this.wordMeshes = [];
    this.wordToMeshIndex = {};
    this.scene = scene;
    this.time = 0;
    this.models = {};
    this.total = 5;
    this.allMeshes = [];
    this.shuffleCount = 0;
    this.loader = new GLTFLoader();
    this.friends = {"1":{words:[],currGroup:null,groups:{} },"2":{words:[],currGroup:null,groups:{}} };
    this.letterScale = 1.025;
    this.letterWidth = .1;
    this.holdingWordInBeak = false;
    this.closeLimit = 4.5;
    this.origCloseLimit = 4.5;
    this.flagH = .654;
    this.flagX = 0;//.025;

    // this.onFloorColor = ;

    // this.userColors = [];
    this.userColors = [0xef8a40,0xee65c9,0xc463ff];

    this.letterData = {};
    const letters = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"," "];
    letters.forEach((letter, i) => {
      this.letterData[letter] = {"width":.09};
    });
    this.letterData["I"].width = .075;
    this.letterData["L"].width = .08;
    this.letterData["M"].width = .15;
    this.letterData["W"].width = .15;

    this.posVec = new THREE.Vector3();

  }

  async init(levelName = "community", allWords = null){

    if(this.wordMeshes.length > 0){
      this.isInited = false;
      this.clearWordsForNewLevel();
    }

    // select only words for this level
    // if(allWords == null){
    //   allWords = [];
    //   for(let i = 0; i < Keywords.length; i++){
    //     if(KeywordToData[Keywords[i]].style == levelName )
    //       allWords.push(Keywords[i]);
    //   }
    // }

    // for each word, create the word with the letter models
    for(let i = 0; i < allWords.length; i++){

      let word = allWords[i];
      let group = new THREE.Group();
      group.name = word;

      // calculate length of the word
      let wordLen = 0;
      for(let j = 0; j < word.length; j++){
        let width = this.letterData[ word[j].toUpperCase() ].width;
        wordLen += (width*this.letterScale);
      }

      // add each letter to group
      let xOffset = 0;
      for(let j = 0; j < word.length; j++){

        if(word[j] != ' '){
          let letterMesh = this.addLetterToGroup(word[j],group,word,xOffset,wordLen);
          this.allMeshes.push(letterMesh);
        }
        let width = this.letterData[ word[j].toUpperCase() ].width;
        xOffset +=  width * this.letterScale;
      }

      group.wordLen = xOffset;
      group.opos = new THREE.Vector3();
      group.myIndex = i;
      this.wordMeshes.push(group);
      this.wordToMeshIndex[word] = this.wordMeshes.length - 1;
    }

    this.isInited = true;
    return true;
  }

  clearWordsForNewLevel(){
    this.wordMeshes.forEach((item, i) => {
      this.scene.remove( item );
    });

    this.allMeshes = [];
    this.wordMeshes = [];
    this.wordToMeshIndex = {};
  }

  addLetterToGroup(letter,group,word,xOffset,wordLen){

    let mesh = clone(this.models[ letter.toUpperCase() ]);
    mesh.traverse( (child) => {
      if(child.isMesh){
        if(child.material.color.r <= 0){child.isBlack = true;}
        child.material = new THREE.MeshToonMaterial({color: new THREE.Color(0xFFE744), transparent: true, opacity: 1});
        //if(child.isBlack){child.material.color = new THREE.Color(0x000000);      }
        child.name = "letter";
        child.mom = group;
        child.word = word;
        //child.castShadow = true;
      }
    });

    let angle = -Math.PI/2 + xOffset*(Math.PI/10);

    mesh.scale.set(this.letterScale,this.letterScale,this.letterScale);
    mesh.position.x = xOffset - (wordLen/2 );
    mesh.opos = new THREE.Vector3().copy(mesh.position);
    group.add(mesh);

    return mesh;
  }

  placeWordsOnTiles(tiles,flamingos,benchTiles,disallowedTiles = []){

    let position = new THREE.Vector3();
    let tileCount = 0;

    // filter tiles with treesm elders or not visible
    let myTiles = [];
    tiles.forEach((item, i) => {
      if(!benchTiles.includes(i) && !item.holdForBench && item.tileType != "tree" && item.hasTree != true && !item.hasElder && item.usable && !disallowedTiles.includes(item.tileIndex))
        myTiles.push(item);
    });


    // solution words
    // let solutions = [];
    // for(let i = 0; i < flamingos.length; i++){
    //   if(i > 0)
    //     solutions.push(flamingos[i]['question']['solution']);
    //   else
    //     solutions.push("");
    // }


    // find distance to flamingos and choose tile for each solution
    // let solutionsIndices = [];
    // let solutionToTileIndex = {};
    //
    // for(let i = 1; i < flamingos.length; i++){
    //     let myFlamingoTiles = [];
    //     let fPos = flamingos[i].group.position;
    //     myTiles.forEach((item, i) => {
    //       let dist = getDistance(fPos.x,fPos.z,item.position.x,item.position.z);
    //       if( dist > 1 && dist < 6 && !solutionsIndices.includes(item.tileIndex) ){
    //         myFlamingoTiles.push(item);
    //       }
    //       if(!item.flamingoDist)
    //         item.flamingoDist = dist;
    //       else if(dist < item.flamingoDist)
    //         item.flamingoDist = dist;
    //     });
    //     // myFlamingoTiles.sort((a, b) => 0.5 - Math.random());
    //     myFlamingoTiles.sort((a,b) => (a.flamingoDist > b.flamingoDist) ? 1 : ((b.flamingoDist > a.flamingoDist) ? -1 : 0))
    //
    //     myFlamingoTiles[0].flamingoDist = 2000;
    //     solutionsIndices.push(myFlamingoTiles[0].tileIndex);
    //     solutionToTileIndex[ flamingos[i]['question']['solution'] ] = {"tileIndex":myFlamingoTiles[0].tileIndex};
    //
    // }

    // make sure no duplicates
    // myTiles.forEach((item, i) => {
    //   if(solutionsIndices.includes(item.tileIndex)){
    //     //console.log("pre duplicate ", item.tileIndex);
    //     myTiles[i].flamingoDist = 2000;
    //   }
    // });

    // filter by distance
    // myTiles = myTiles.filter( (item) => {
    //   return (item.flamingoDist < 4) ;
    // });

    myTiles = myTiles.filter( (item) => {
      return (item.len < 6) ;
    });


    myTiles.sort((a, b) => 0.5 - Math.random());

    // choose tile foe each word
    for(let i = 0; i < this.wordMeshes.length; i++){

      let group = this.wordMeshes[i];
      let tile = myTiles[0];

      // if( solutions.includes(group.name) ){
      //
      //   let tileIndex = solutionToTileIndex[group.name].tileIndex;
      //   tile = tiles[tileIndex];
      //   group.tileIndex = tileIndex;
      //   tiles[group.tileIndex].hasWord = true;
      //
      //
      // }else{

        group.tileIndex = tile.tileIndex;
        tiles[group.tileIndex].hasWord = true;
        myTiles.shift();


      // }

      group.showing = false;

      position.copy(tile.position);
      position.y = tile.scale.y*.5;

      //temp debug
      if(!PLACE_WORDS)
        position.y = 10000;

      group.state = "tile-hidden";
      group.position.set(position.x,position.y,position.z);
      group.opos = new THREE.Vector3(position.x,position.y,position.z);
      this.setState(group,"tile-hidden",0);

      this.scene.add(group);
      group.inScene = true;
      group.visible = false;

      tileCount++;
    }
  }

  updateWordHeights(tileData){
    let position = new THREE.Vector3();
    for(let i = 0; i < this.wordMeshes.length; i++){
      let group = this.wordMeshes[i];
      group.position.y = tileData[group.tileIndex].noise * .5 - .25;
    }
  }

  updateTileHasWord(index,fpos){

    this.wordMeshes.forEach((item, i) => {

      if(item.tileIndex == index && (item.state == "tile-hidden" || item.state == "tile-closeto") ){
        item.state = "tile-showing";
        this.setState(item,"tile-showing");

        // if(item.state != "chosen")
        //   item.lookAt(new THREE.Vector3(fpos.x,item.position.y,fpos.z));

        if(this.wordShowing != item && this.wordShowing != null && this.wordShowing.state != "chosen"){
          this.wordShowing.state = "tile-closeto";
          this.setState(this.wordShowing,"tile-closeto");
        }

        this.wordShowing = item;

      }else if(item.tileIndex != index && item.state == "tile-showing"){
        item.state = "tile-closeto";
        this.setState(item,"tile-closeto");
      }
    });
  }

  openedWordBank(){
    this.wordMeshes.forEach((item, i) => {
      if(item.state == "tile-showing"){
        item.state = "tile-closeto";
        this.setState(item,"tile-closeto");
      }
    });
  }

  selectedFromWordBank(word,fpos){
    // close previous
    this.wordMeshes.forEach((item, i) => {
      if(item.state == "tile-showing"){
        item.state = "tile-closeto";
        this.setState(item,"tile-closeto");
      }

      if(item.name == word){
        item.children.forEach((child, i) => {
          child.position.copy(child.opos);
          child.position.y = 0;
          child.rotation.set(0,0,0);

          // gsap.to(child.position,{y:.20,delay: 0,duration:1*i,overwrite:true});//.25 + (.1*i)});
          // gsap.to(child.rotation,{x:Math.PI/2,delay: 0,duration:0,overwrite:true});

        });
        item.position.copy(item.opos);
        item.rotation.set(0,0,0);
        //item.lookAt(fPos);
        item.lookAt(new THREE.Vector3(fpos.x,item.position.y,fpos.z));

        this.setState(item,"tile-closeto-wordbank");

        this.wordShowing = item;
        item.visible = true;
      }
    });

    this.flamingoSelectedWord(true);
  }

  update(dt,flamingos,camera,birds){

    let fpos = flamingos[0].group.position;

    this.fpos = fpos;
    this.time += dt;

    let closeWords = [];
    const closeLimit = this.closeLimit;

    this.wordMeshes.forEach((item, i) => {

      let dist = item.position.distanceTo(fpos);
      if(item.state == "remove"){
        // do nothing for now ?
      }else if(dist > 0 && dist < closeLimit ){

        // set close to tile
        if (item.state != "tile-showing" && item.state != "chosen" && item.state != "bird" && item.state != "overhead" && item.state != "tile-closeto" && item.state != "hidden"){
          item.state = "tile-closeto";
          this.setState(item,"tile-closeto");
        }

      }else if(item.state == "tile-showing" || item.state == "tile-closeto"){
        if (item.state != "chosen" && item.state != "bird" && item.state != "overhead"){
          let prevState = item.state;
          item.state = "tile-hidden";
          this.setState(item,"tile-hidden");
        }
      }

    });

    for(let i = 0; i < this.wordMeshes.length; i++){
      let mesh = this.wordMeshes[i];

      // look at camera when close or on tile (showing)
      if(mesh.state == "tile-closeto" || mesh.state == "tile-showing"){
        this.posVec.set(0,0,0).copy(camera.position);
        this.posVec.y = mesh.position.y;
        //let pos = new THREE.Vector3().copy(camera.position);
        mesh.lookAt(this.posVec);

      }

      // floatig animation
      if(mesh.state == "tile-closeto"){

        mesh.children.forEach((child, j) => {
          if(child.name != "box"){
            child.position.z = child.opos.z + Math.sin( this.time + j) * 0.012;
            child.position.y = child.opos.y + Math.sin( this.time + j*2) * 0.012;
          }
        });

      }

      // floating when showing on tile
      if(mesh.state == "tile-showing" && mesh.state != "chosen"){

          mesh.children.forEach((child, j) => {
            if(child.name != "box")
              child.position.y = child.opos.y + Math.sin( this.time + j*3) * 0.012;
          });
      }
      else if(mesh.state == "chosen"){

        //let pos = new THREE.Vector3().copy(flamingos[0].box.position);
        this.posVec.set(0,0,0).copy(flamingos[0].box.position);
        flamingos[0].corps.localToWorld(this.posVec);
        this.posVec.y += .025;

        let x = .8 * mesh.position.x + .2 * (this.posVec.x);// - mesh.wordLen*.5);
        let y = .75 * mesh.position.y + .25 * (this.posVec.y);
        let z = .8 * mesh.position.z + .2 * this.posVec.z;

        mesh.position.copy(this.posVec);
        this.posVec.set(fpos.x,mesh.position.y,fpos.z);
        mesh.lookAt(this.posVec);

      }else if(mesh.state == "overhead"){
        //let pos = new THREE.Vector3().copy(flamingos[0].group.position);
        this.posVec.set(0,0,0).copy(flamingos[0].group.position);
        this.posVec.y += 1;
        let x = .9 * mesh.position.x + .1 * (this.posVec.x);// - mesh.wordLen*.5);
        let y = .9 * mesh.position.y + .1 * (this.posVec.y);
        let z = .9 * mesh.position.z + .1 * this.posVec.z;

        mesh.position.set(x,y,z);//x,y,z);

        //let bpos = new THREE.Vector3().copy(flamingos[0].lookBack.position);
        this.posVec.copy(flamingos[0].lookBack.position);
        flamingos[0].corps.localToWorld(this.posVec);
        mesh.lookAt(camera.position);

      }

    }


  }

  updateState(mesh,flamingo,bird){
    if(mesh.state == "bird"){
      mesh.rotation.set(0,0,0);
      mesh.children.forEach((child, j) => {
        let index = mesh.children.length - j;
        let bannerLetter = bird.banner[index];
        let target = new THREE.Vector3();
        bannerLetter.getWorldPosition(target);
        mesh.worldToLocal(target);

        let me = .9 - (.015 * (j+1));
        let them = 1 - me;
        child.position.x = me * child.position.x + them * target.x;
        child.position.y = me * child.position.y + them * target.y;
        child.position.z = me * child.position.z + them * target.z;

        let quat = new THREE.Quaternion();
        bannerLetter.getWorldQuaternion(quat);
        child.quaternion.copy(quat);
      });
    }
  }

  setState(group,state, delay=0){

    if(state == "tile-hidden"){
      // group.children.forEach((item, i) => {
      //   item.position.y = .25;
      //   gsap.to(item.position,{y:.20,delay: 0,duration:1*i,overwrite:true});//.25 + (.1*i)});
      //
      // });
      // group.position.y = group.opos.y-.25;
      // this.resetLetterColors(group);
      group.rotation.set(0,0,0);
      group.children.forEach((item, i) => {
        gsap.to(item.rotation,{x:Math.PI/2,y:0,z:0,delay: 0,duration:0});
        gsap.to(item.position,{y:0,delay: 0,duration:.25 + (.1*i), overwrite:true});
      });
      group.position.y = group.opos.y + this.flagH;

      this.resetLetterColors(group);
      group.visible = false;

    }else if(state == "remove"){

      group.children.forEach((item, i) => {
        item.position.y = .25;
        gsap.to(item.position,{y:.20,delay: 0,duration:1*i,overwrite:true});//.25 + (.1*i)});
        gsap.to(item.rotation,{x:Math.PI/2,delay: 0,duration:0,overwrite:true});

      });
      group.visible = false;
      group.state = "removed";
      group.position.copy(group.opos);
      group.rotation.set(0,0,0);
      group.position.y = 100000;//group.opos.y-.25;

        // if(group.parent.getObjectByName(group.name))
        //   group.parent.remove(group);

    }else if(state == "tile-closeto"){

      // when flamingo is close to the word
      // group.children.forEach((item, i) => {
      //   gsap.to(item.rotation,{x:Math.PI/4,y:Math.random(),delay: 0,duration:0});
      //   gsap.to(item.position,{y:.225,delay: 0,duration:.25 + (.1*i), overwrite:true});
      // });

      group.children.forEach((item, i) => {
        gsap.to(item.rotation,{x:Math.PI/2,y:0,delay: 0,duration:0});
        gsap.to(item.position,{y:0,x:(item.opos.x+group.wordLen*0+this.flagX),delay: 0,duration:.25 + (.1*i), overwrite:true});
      });
      group.position.y = group.opos.y + this.flagH;
      group.rotation.set(0,0,0);

      this.resetLetterColors(group);
      group.visible = true;

      this.fire("close_to",group.myIndex);
    }else if (state == "tile-closeto-wordbank"){

      group.children.forEach((item, i) => {
        gsap.to(item.rotation,{x:0,y:0,delay: 0,duration:0});
        gsap.to(item.position,{y:.25,delay: 0,duration:0, overwrite:true});
      });

      this.resetLetterColors(group);
      group.visible = true;

    }else if(state == "tile-showing"){
      // when flamingo is on the tile
      group.visible = true;
      group.children.forEach((item, i) => {
        item.position.y = 0;
        gsap.to(item.rotation,{x:Math.PI/2,y:0,delay: 0,duration:0});
      //  gsap.to(item.position,{y:0,delay: 0,duration:.25 + (.1*i), overwrite:true});
        gsap.to(item.position,{y:0,x:(item.opos.x+group.wordLen*0+this.flagX),delay: 0,duration:.25 + (.1*i), overwrite:true});

      });

      //group.position.y = group.opos.y-.25;
      group.position.y = group.opos.y + this.flagH;

      // this.setLetterColors(group,this.userColors[0]);

    }else if(state == "chosen"){
      group.visible = true;
      group.children.forEach((item, i) => {
        gsap.to(item.rotation,{x:Math.PI/2,y:0,delay: delay,duration:.25});
        gsap.to(item.position,{y:0,delay: delay,duration:.25,overwrite:true});
      });

      gsap.to(group.scale,{x:.5,y:.5,z:.5,duration:.5});

    }else if(state == "choosing"){
      group.visible = true;
      group.children.forEach((item, i) => {
        gsap.to(item.rotation,{x:Math.PI/2,y:0,delay: delay,duration:.25 + (.1*i)});
      });
      gsap.to(group.scale,{x:1,y:1,z:1,duration:.5});
      // gsap.to(group.position,{x:fpos.,y:,z:});
    }else if(state == "bird"){

      group.visible = true;
      gsap.to(group.scale,{x:1,y:1,z:1,duration:.5});
    }else if(state == "overhead"){
      //console.log("set state overhead");
      group.visible = true;
      //gsap.to(group.scale,{x:1,y:1,z:1,duration:.5});
      group.children.forEach((item, i) => {
        item.traverse( (child) => {
          if(child.isMesh){
            gsap.to(child.material,{opacity:0,duration:2});
            child.castShadow = false;

          }
        });
      });
    }

  }

  getModelPaths(){
    let paths = [];
    // const letters = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"];
    const letters = ["A","B","C","E","G","H","I","L","M","N","O","P","R","S","T","U","V","Y"];
    letters.forEach((letter, i) => {
      let path = {path:"./models/letter_" + letter + ".glb", letter:letter};
      paths.push(path);
    });

    return paths;
  }

  hitLetter(mesh){
    //this.fire("tell_about_word",group.name);
    this.flamingoSelectedWord();
  }

  wordIsPlaying(){
    if(!this.chosenWord)
      return;
    let group = this.chosenWord;//this.wordShowing;
    // group.state = "bird";
    // this.setState(group, "bird");

    group.state = "overhead";
    this.setState(group, "overhead");

    this.holdingWordInBeak = false;
  }

  flamingoSelectedWord(fromWordBank = false){
    if(!this.wordShowing)
      return;

    //console.log("flamingoSelectedWord fromWordBank",fromWordBank);

    let group = this.wordShowing;

    if(this.prevWordShowing){
      this.prevWordShowing.parent.remove(this.prevWordShowing);
      this.prevWordShowing = null;
    }

    this.resetLetterColors(group);
    group.visible = true;
    group.children.forEach((item, i) => {
      item.traverse( (child) => {
        if(child.isMesh){
          // child.material = new THREE.MeshToonMaterial(
          //   {color: new THREE.Color(0xFFE744), transparent: true, opacity: 1
          //   });

            child.material.opacity = 1;
            child.material.transparent = true;

            if(!fromWordBank){
              gsap.to(child.material,{opacity:0,duration:.5,onComplete:function(){
                group.visible = false;
              }.bind(this)});
              child.castShadow = false;
            }

          //child.material = new THREE.MeshToonMaterial({color:new THREE.Color(0xF68423), emissive:new THREE.Color(0x663a09)})
        }
      });
    });

    if(!fromWordBank){
      this.fire("selected_word_from_world",group.name);
      this.fire("update_signpost",group.myIndex);
    }

    this.fire("play_word",group.name);
    this.fire("no_longer_has_word",group.tileIndex);
    this.flamingoPlayedWord();

  }

  setLetterColors(group,color){
    group.children.forEach((item, i) => {
      item.traverse( (child) => {
        if(child.isMesh){
          // if(child.isBlack == true){
          //   child.material.color = new THREE.Color(0x000000);
          // }else{
            child.material = new THREE.MeshToonMaterial({color: new THREE.Color(color)});
          // }
        }
      });
    });
  }

  resetLetterColors(group){
    group.traverse( (child) => {
      if(child.isMesh){
        // if(child.isBlack == true){
        //   child.material.color = new THREE.Color(0x000000);
        // }else{
          child.material.color = new THREE.Color(0xFFE744);
        // }


      }
    });
  }

  wordErroredOut(){
    if(this.chosenWord){
      this.chosenWord.state = "remove";
      this.setState(this.chosenWord,"remove");
    }
    this.wordShowing = null;
    this.chosenWord = null;
    this.holdingWordInBeak = false;
  }

  selectedWhileWaiting(){
    if(this.wordShowing){
      this.wordShowing.state = "remove";
      this.setState(this.wordShowing,"remove");
    }
    this.wordShowing = null;
  }

  flamingoPlayedWord(){

    //console.log("flamingoPlayedWord");

    if(this.chosenWord){
      this.chosenWord.state = "remove";
      this.setState(this.chosenWord,"remove");
    }

    let group = this.wordShowing;

    this.chosenWord = group;

    setTimeout( function(){
      group.state = "chosen";
      this.setState(group, "chosen");
    }.bind(this), 20);

    this.wordShowing = null;
    this.holdingWordInBeak = true;
  }

  getAllMeshes(){

    return this.allMeshes;
  }

  getShowingLetterMeshes(){
    if(!this.wordShowing)
      return [];
    let group = this.wordShowing;
    return group.children;
  }


  async loadModel(url) {
    return new Promise((resolve, reject) => {
      this.loader.load(url, data=> resolve(data), null, reject);
    });
  }



};
